/**
 * Google IMA HTML5
 */
class GoogleIMAAds implements Networks.AdInstance
{
    private adsBlocked: boolean;
    private adsVideoPlayerElement: HTMLVideoElement;
    private adsContainerElement: HTMLElement;
    private adsDisplayContainer: google.ima.AdDisplayContainer;

    private adsLoader: google.ima.AdsLoader;
    private adsManager: google.ima.AdsManager;

    private videoPlaybackResolve: (value?: {} | PromiseLike<{}>) => void
    private videoPlaybackReject: (reason?: any) => void;

    /**
     * Constructor
     */
    constructor()
    {
        // Get display elements
        const adsContainerElement = document.getElementById('ads-container');
        const adsVideoPlayerElement = document.getElementById('ads-player') as HTMLVideoElement;
        const adsSDKContainerElement = document.getElementById('ads-sdk-container');

        if( typeof google !== 'undefined' && typeof google.ima !== 'undefined' )
        {
            // Create ads display container
            const adsDisplayContainer = new google.ima.AdDisplayContainer(adsSDKContainerElement, adsVideoPlayerElement);

            // Create ads loader
            const adsLoader = new google.ima.AdsLoader(adsDisplayContainer);
            adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.adsManagerLoaded);
            adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError);

            this.adsBlocked = false;
            this.adsContainerElement = adsContainerElement;
            this.adsVideoPlayerElement = adsVideoPlayerElement;
            this.adsDisplayContainer = adsDisplayContainer;
            this.adsLoader = adsLoader;
            this.videoPlaybackResolve = Promise.resolve;
            this.videoPlaybackReject = Promise.reject;
        }
        else
        {
            this.adsBlocked = true;
        }
    }

    /**
     * Get placement ID
     */
    public getPlacementID(): string
    {
        throw new Error("Method not implemented.");
    }

    /**
     * Callback for when ads manager is loaded
     */
    private adsManagerLoaded = (adsManagerEvent: google.ima.AdsManagerLoadedEvent) =>
    {
        const adsRenderingSettings = new google.ima.AdsRenderingSettings();
        adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;

        const adsManager = adsManagerEvent.getAdsManager(this.adsVideoPlayerElement);
        adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError);
        adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, this.hideContainerElement);
        adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, this.onComplete);
        adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, this.onStarted);
        adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, this.onSkipped);
        adsManager.addEventListener(google.ima.AdEvent.Type.USER_CLOSE, this.onUserClosed);

        this.adsManager = adsManager;
    }

    /**
     * Fires when ad has completed playing
     */
    private onComplete = () =>
    {
        this.hideContainerElement();
        this.videoPlaybackResolve();
    }

    /**
     * Fires when ad has started playing
     */
    private onStarted = () =>
    {
        this.showVideoElement();
    }

    /**
     * Fires when ad has been skipped
     */
    private onSkipped = () =>
    {
        this.hideContainerElement();
        this.videoPlaybackResolve();
    }

    /**
     * Fires when a user has closed the video
     */
    private onUserClosed = () => {
        this.hideContainerElement();
        this.videoPlaybackResolve();
    }

    /**
     * Shows video element
     */
    private showVideoElement = () =>
    {
        const adsContainerElement = this.adsContainerElement;
        adsContainerElement.style.display = 'block';
    }

    /**
     * Hides video element
     */
    private hideContainerElement = () =>
    {
        const adsContainerElement = this.adsContainerElement;
        adsContainerElement.style.display = 'none';
    }

    /**
     * Requests an ad from the ads loader
     */
    public async loadAsync()
    {
        if( this.adsBlocked === false )
        {
            const videoElement = this.adsVideoPlayerElement;
            const videoWidth = videoElement.width;
            const videoHeight = videoElement.height;

            const adsRequest = new google.ima.AdsRequest();

            adsRequest.adTagUrl = 'https://googleads.g.doubleclick.net/pagead/ads?' +
                'ad_type=skippablevideo_image_text&' +
                'client=ca-games-pub-6637860066696198&' +
                'description_url=' + window.location.href +
                '&videoad_start_delay=0&hl=en';

            adsRequest.forceNonLinearFullSlot = true;
            adsRequest.linearAdSlotWidth = videoWidth;
            adsRequest.linearAdSlotHeight = videoHeight;
            adsRequest.nonLinearAdSlotWidth = videoWidth;
            adsRequest.nonLinearAdSlotHeight = videoHeight;

            this.adsLoader.requestAds(adsRequest);
        }
    }

    /**
     * Shows ads
     */
    public async showAsync(): Promise<void>
    {
        const self = this;

        async function displayAd()
        {
            return new Promise((resolve, reject) =>
            {
                self.videoPlaybackResolve = resolve;
                self.videoPlaybackReject = reject;

                try {
                    const displayMode = google.ima.ViewMode.NORMAL;

                    const videoElement = self.adsVideoPlayerElement
                    videoElement.style.display = 'block';

                    const videoWidth = videoElement.width;
                    const videoHeight = videoElement.height;

                    self.adsDisplayContainer.initialize();
                    self.adsManager.init(videoWidth, videoHeight, displayMode);
                    self.adsManager.start();
                }
                catch(error)
                {
                    reject(error);
                }
            });
        }

        if( this.adsBlocked === false )
        {
            await displayAd();
        }

    }


    /**
     * Handles ad errors
     */
    private onAdError = (adErrorEvent: google.ima.AdErrorEvent) =>
    {
        this.hideContainerElement();
        this.videoPlaybackReject(adErrorEvent);
    }

}


export default GoogleIMAAds;
